import axios from 'axios';
import { Todo, TodoFormData } from '../types/todo';

// APIベースURL（本番では相対パス、開発ではlocalhost）
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/todo/api/todos'
  : 'http://localhost:8080/api/todos';

// Axiosインスタンスの作成
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 日付をISO形式に変換するヘルパー関数
const formatDateForApi = (date: string | null): string | null => {
  if (!date) return null;
  // すでにISO形式（Tを含む）の場合はそのまま返す
  if (date.includes('T')) return date;
  // YYYY-MM-DD形式をISO形式に変換
  return new Date(date + 'T00:00:00Z').toISOString();
};

// API関数
export const todoApi = {
  // 全てのToDoを取得
  getAll: async (): Promise<Todo[]> => {
    const response = await apiClient.get<Todo[]>('');
    return response.data;
  },

  // 特定のToDoを取得
  getById: async (id: number): Promise<Todo> => {
    const response = await apiClient.get<Todo>(`/${id}`);
    return response.data;
  },

  // 新しいToDoを作成
  create: async (data: TodoFormData): Promise<Todo> => {
    const payload = {
      ...data,
      due_date: formatDateForApi(data.due_date),
    };
    const response = await apiClient.post<Todo>('', payload);
    return response.data;
  },

  // ToDoを更新
  update: async (id: number, data: TodoFormData): Promise<Todo> => {
    const payload = {
      ...data,
      due_date: formatDateForApi(data.due_date),
    };
    const response = await apiClient.put<Todo>(`/${id}`, payload);
    return response.data;
  },

  // ToDoを削除
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/${id}`);
  },
};

export default todoApi;
